import React from "react";

function Color_Currentcolor() {
  return (
    <div>
      <h1>Color_Currentcolor Component</h1>
      <p>This is the Color Currentcolor tutorial page content.</p>
    </div>
  );
}

export default Color_Currentcolor;
